import React from 'react';
// @ts-ignore
import styles from './PatientProfileLite.module.scss';
import { User } from '../../../../graphql/graphql';
import PatientProfileV2 from '../../../../Components/PatientProfile/PatientProfileV2';
import { Theme } from '../../../../Enums/Theme.enum';
import Button from '../../../../Components/Button/Button';
import Text from '../../../../Components/Base/Text/Text';
import { acceptCase } from '../../../Case/Services/case.service';
import useLoading from '../../../Base/Hooks/useLoading';
import { useAppContext } from '../../../../Services/AppContext';
import useApiClient from '../../../Base/Hooks/useApiClient';

interface Props {
	patient: User;
	caseId?: string;
}

const PatientProfileLite: React.FC<Props> = ({ patient, caseId }) => {
	const { setIsLoading, isLoading, RenderLoading } = useLoading();
	const { displayError } = useApiClient();
	const { userData } = useAppContext();

	//ACCEPT CASE AND REDIRECT TO CASE DETAIL
	const handleConnect = async (caseId: string) => {
		setIsLoading(true);
		try {
			await acceptCase(caseId, userData.id, true, true);
		} catch (e) {
			displayError(e);
		}
		setIsLoading(false);
	};

	if (isLoading) return <RenderLoading />;

	return (
		<div className={styles.wrapper}>
			<Text
				className={styles.text}
				tx='component.patientProfileLite.patientIsNotInEArchive'
			/>
			<PatientProfileV2 patientId={patient.id} allowProfileEdit={false} />
			{caseId && (
				<div className={styles.controls}>
					<Button
						title={'base.shared.contactAPatient'}
						theme={Theme.GREEN}
						onClick={() => handleConnect(caseId)}
						fitContent
					/>
				</div>
			)}
		</div>
	);
};

export default PatientProfileLite;
